module.exports = __webpack_public_path__ + "assets/img/portal_bg_one.fbd2502b.png";